"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsProfile = void 0;
exports.settingsProfile = {
    name: 'settings',
    methods: ['getGithubAccessToken'],
};
//# sourceMappingURL=profile.js.map